import {
  AbilityBuilder,
  AbilityClass,
  ConditionsMatcher,
  mongoQueryMatcher,
  PureAbility
} from '@casl/ability';

import { UserProfileType } from '~/shared/types/profile';
import { isProxyEnabled } from '~/shared/utils/environments';

enum Action {
  Create = 'create',
  Edit = 'edit',
  View = 'view',
  List = 'list',
  Manage = 'manage',
  Vote = 'vote',
  Facilitate = 'facilitate',
  Proxy = 'proxy',
  Unlock = 'unlock',
  Skip = 'skip',
  Delete = 'delete',
  Download = 'download'
}

export enum EntitiesEnum {
  Home = 'Home',
  Proxy = 'Proxy',
  User = 'User',
  Stellar = 'Stellar',
  Footer = 'Footer',
  Cheershub = 'Cheershub',
  Requests = 'Requests',
  MyAccess = 'MyAccess',
  ToApprove = 'ToApprove',
  Report = 'Report',
  Guide = 'Guide'
}

export type Entities = EntitiesEnum;

export type AbilityTuple = [`${Action}`, Entities | Record<string, unknown>];

export type AppAbility = PureAbility<AbilityTuple>;

type UserWithRoles = {
  roles?: {
    isGlobalAdmin?: boolean;
  };
};

export function createUserAbility(
  user: UserWithRoles,
  rules?: AppAbility['_indexedRules'],
  profileType?: UserProfileType
) {
  const { can, build } = new AbilityBuilder(
    PureAbility as AbilityClass<AppAbility>
  );

  const mainUserRoles = user?.roles;

  can(Action.View, EntitiesEnum.Home);
  can(Action.View, EntitiesEnum.Footer);
  can(Action.View, EntitiesEnum.Requests);
  can(Action.View, EntitiesEnum.MyAccess);
  can(Action.View, EntitiesEnum.ToApprove);
  can(Action.View, EntitiesEnum.Guide);

  if (mainUserRoles?.isGlobalAdmin) {
    can(Action.View, EntitiesEnum.Cheershub);

    if (isProxyEnabled()) {
      can(Action.Proxy, EntitiesEnum.User);
      can(Action.Proxy, EntitiesEnum.Proxy);
      can(Action.View, EntitiesEnum.Proxy);
    }
  }

  if (profileType) {
    if (profileType === 'Administrator' || profileType === 'Zone Spoc') {
      can(Action.View, EntitiesEnum.Report);
    }

    if (profileType === 'Administrator') {
      can(Action.Manage, EntitiesEnum.User);
      can(Action.Manage, EntitiesEnum.Requests);
    }
  }

  const ability = build({
    conditionsMatcher: mongoQueryMatcher as ConditionsMatcher<unknown>
  });

  if (rules) {
    ability.update(rules);
  }

  return ability;
}
